import { render, staticRenderFns } from "./BillingHistoryManagement.vue?vue&type=template&id=67e41d1a&scoped=true"
import script from "./BillingHistoryManagement.vue?vue&type=script&lang=js"
export * from "./BillingHistoryManagement.vue?vue&type=script&lang=js"
import style0 from "./BillingHistoryManagement.vue?vue&type=style&index=0&id=67e41d1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e41d1a",
  null
  
)

export default component.exports